/**
 * Decode JWT token to get user information
 * Note: This only decodes the payload, it doesn't verify the signature
 * For reading user info from a stored token, this is safe
 */
export const decodeToken = (token) => {
  try {
    if (!token) return null;
    
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    
    const payload = parts[1];
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return decoded;
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

/**
 * Get current user role from token
 */
export const getUserRole = () => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  
  const decoded = decodeToken(token);
  return decoded?.role || null;
};

/**
 * Check if current user is admin
 */
export const isAdmin = () => {
  const role = getUserRole();
  return role === 'admin';
};

/**
 * Get current user info from localStorage or token
 */
export const getCurrentUser = () => {
  // First try to get from localStorage (stored on login)
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      return JSON.parse(userStr);
    } catch (e) {
      // If parsing fails, try token
    }
  }
  
  // Fallback to decoding token
  const token = localStorage.getItem('token');
  if (token) {
    const decoded = decodeToken(token);
    if (decoded) {
      return {
        id: decoded.id,
        email: decoded.email,
        role: decoded.role,
      };
    }
  }
  
  return null;
};

